'use client';

import { useState } from 'react';
import HotelSearchForm from './HotelSearchForm';
import HotelFilters from './HotelFilters';
import HotelResults from './HotelResults';

export interface HotelSearchParams {
  destination: string;
  checkIn: string;
  checkOut: string;
  guests: number;
  rooms: number;
}

const HotelSearchInteractive = () => {
  const [searchParams, setSearchParams] = useState<HotelSearchParams>({
    destination: 'New York',
    checkIn: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    checkOut: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    guests: 2,
    rooms: 1,
  });
  const [hasSearched, setHasSearched] = useState(true);

  const handleSearch = (params: HotelSearchParams) => {
    setSearchParams(params);
    setHasSearched(true);
  };

  return (
    <section className="py-8 lg:py-12">
      <div className="container mx-auto px-4">
        {/* Search Form */}
        <div className="mb-8">
          <HotelSearchForm onSearch={handleSearch} initialParams={searchParams} />
        </div>

        {hasSearched && (
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Filters Sidebar */}
            <aside className="lg:w-64 flex-shrink-0">
              <HotelFilters />
            </aside>
            
            {/* Results */}
            <div className="flex-1">
              <HotelResults searchParams={searchParams} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HotelSearchInteractive;